import { useForm } from "react-hook-form";
import { motion } from "framer-motion";
import { FiUser, FiMail, FiPhone, FiBriefcase, FiLock } from "react-icons/fi";
import { useState } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import { server } from "../../server";

export default function RegisterEmployee() {
  const {
    reset,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [loading, setLoading] = useState(false);

  const onSubmit = async (data) => {
    try {
      setLoading(true);
      const { data: resData } = await axios.post(
        `${server}/auth/register`,
        null,
        {
          params: {
            name: data?.name,
            email: data?.email,
            mobile: data?.phone,
            password: data?.password,
            position: data?.position,
          },
        }
      );

      toast.success(resData?.message);
      reset();
      setLoading(false);
    } catch (e) {
      setLoading(false);
      toast.error(e?.response?.data);
    }
  };

  return (
    <div className="min-h-[90vh] flex items-center justify-center p-6">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="bg-white shadow-lg rounded-xl max-w-md w-full p-8"
      >
        <h2 className="text-2xl font-bold mb-6 text-gray-800 text-center">
          Register Employee
        </h2>

        <form onSubmit={handleSubmit(onSubmit)} className="space-y-5">
          {/* Full Name */}
          <div>
            <label className="block mb-1 font-semibold text-gray-700 flex items-center gap-2">
              <FiUser /> Full Name
            </label>
            <input
              type="text"
              placeholder="Your name"
              {...register("fullName", { required: "Full name is required" })}
              className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 ${
                errors.fullName
                  ? "border-red-500 focus:ring-red-500"
                  : "border-gray-300 focus:ring-blue-500"
              }`}
            />
            {errors.fullName && (
              <p className="text-red-500 text-sm mt-1">
                {errors.fullName.message}
              </p>
            )}
          </div>

          {/* Email */}
          <div>
            <label className="block mb-1 font-semibold text-gray-700 flex items-center gap-2">
              <FiMail /> Email Address
            </label>
            <input
              type="email"
              placeholder="your-name@example.com"
              {...register("email", {
                required: "Email is required",
                pattern: {
                  value: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
                  message: "Invalid email address",
                },
              })}
              className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 ${
                errors.email
                  ? "border-red-500 focus:ring-red-500"
                  : "border-gray-300 focus:ring-blue-500"
              }`}
            />
            {errors.email && (
              <p className="text-red-500 text-sm mt-1">
                {errors.email.message}
              </p>
            )}
          </div>

          {/* Phone Number */}
          <div>
            <label className="block mb-1 font-semibold text-gray-700 flex items-center gap-2">
              <FiPhone /> Phone Number
            </label>
            <div className="flex items-center">
              <input
                className="w-12 px-1 text-center py-2 border border-gray-300 rounded-l-lg bg-gray-100 focus:outline-none"
                value={"+91"}
                disabled
              />
              <input
                type="tel"
                placeholder="9988776655"
                {...register("phone", {
                  required: "Phone number is required",
                  pattern: {
                    value: /^[+]?[\d\s-]{7,15}$/,
                    message: "Invalid phone number",
                  },
                })}
                className={`w-full px-4 py-2 border rounded-r-lg focus:outline-none focus:ring-2 ${
                  errors.phone
                    ? "border-red-500 focus:ring-red-500"
                    : "border-gray-300 focus:ring-blue-500"
                }`}
              />
            </div>
            {errors.phone && (
              <p className="text-red-500 text-sm mt-1">
                {errors.phone.message}
              </p>
            )}
          </div>

          {/* Position */}
          <div>
            <label className="block mb-1 font-semibold text-gray-700 flex items-center gap-2">
              <FiBriefcase /> Position
            </label>
            <select
              type="text"
              placeholder="Software Engineer"
              {...register("position", { required: "Position is required" })}
              className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 ${
                errors.position
                  ? "border-red-500 focus:ring-red-500"
                  : "border-gray-300 focus:ring-blue-500"
              }`}
            >
              <option value={""}>Select One</option>
              <option value={"developer"}>Developer</option>
            </select>
            {errors.position && (
              <p className="text-red-500 text-sm mt-1">
                {errors.position.message}
              </p>
            )}
          </div>

          {/* Password */}
          <div>
            <label className="block mb-1 font-semibold text-gray-700 flex items-center gap-2">
              <FiLock /> Password
            </label>
            <input
              type="password"
              placeholder="********"
              {...register("password", {
                required: "Password is required",
                minLength: {
                  value: 6,
                  message: "Password must be at least 6 characters",
                },
              })}
              className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 ${
                errors.password
                  ? "border-red-500 focus:ring-red-500"
                  : "border-gray-300 focus:ring-blue-500"
              }`}
            />
            {errors.password && (
              <p className="text-red-500 text-sm mt-1">
                {errors.password.message}
              </p>
            )}
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            className="w-full bg-blue-600 text-white font-semibold py-3 rounded-lg hover:bg-blue-700 transition"
          >
            Register Employee
          </button>
        </form>
      </motion.div>
    </div>
  );
}
